import axios from '@/request/http'
import base from '@/request/base'

/**
 * 判断是否填写表单
 * @param {number} type 1 注册表单 2课程表单
 */
export const getIsWriteForm = (type) => {
  return axios.get(`${base.url}/newindex/user/is_write_form?type=${type}`)
}

/**
 * 填写表单
 * @param {object} data 问卷表单数据
 */
export const submitForm = (data) => {
  return axios.post(`${base.url}/newindex/user/write_form`, {}, { params: data })
}

/**
 * 是否满足弹出课程弹窗的条件
 */
export const getIsCourse = () => {
  return axios.get(`${base.url}/newindex/user/is_course`)
}
